import Vue from 'vue'
import Vuetify from 'vuetify'
import Snackbar from './components/Snackbar.vue'

export default class Notification {
  constructor () {
    this.vue = Vue
  }

  open (propsData) {
    return new (this.vue.extend(Snackbar))({
      el: document.createElement('div'),
      propsData,
      vuetify: new Vuetify({})
    })
  }

  success (message, options = {}) {
    return this.open({ message,
      type: 'success',
      icon: 'mdi-check-circle-outline',
      color: '#2AB59C',
      ...options
    })
  }

  error (message, options = {}) {
    return this.open({ message,
      type: 'error',
      icon: 'mdi-close-circle-outline',
      color: '#F04D4D',
      ...options
    })
  }

  info (message, options = {}) {
    return this.open({ message,
      type: 'info',
      icon: 'mdi-information-outline',
      color: '#1BA7E1',
      ...options
    })
  }

  warning (message, options = {}) {
    return this.open({ message,
      type: 'warning',
      icon: 'mdi-alert-outline',
      color: '#EDA437',
      ...options
    })
  }

  default (message, options = {}) {
    return this.open({ message,
      type: 'default',
      icon: 'mdi-bell',
      ...options
    })
  }
}
